<section class="evidencia-modal">
  <header class="evidencia-modal__header">
    <div>
      <span class="evidencia-modal__eyebrow">Evidencia</span>
      <h2>{{ nombre }}</h2>
    </div>

    <button
      type="button"
      mat-icon-button
      class="evidencia-modal__close"
      (click)="onCloseClick()"
      aria-label="Cerrar modal"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="evidencia-modal__body" mat-dialog-content>
    <div class="evidencia-modal__fallback" *ngIf="errorCarga">
      <mat-icon>error_outline</mat-icon>
      <p>No se pudo mostrar la evidencia en el navegador.</p>
      <a [href]="image" [download]="nombre" class="evidencia-modal__fallback-link">
        Descargar archivo
      </a>
    </div>

    <div class="evidencia-modal__viewer" *ngIf="!errorCarga && show">
      <img
        [src]="image"
        class="evidencia-modal__image"
        alt="Evidencia {{ nombre }}"
        (error)="onErrorCarga()"
      />
    </div>

    <div class="evidencia-modal__viewer evidencia-modal__viewer--video" *ngIf="!errorCarga && !show">
      <vg-player class="evidencia-modal__player">
        <video
          [vgMedia]="media"
          #media
          id="singleVideo"
          preload="auto"
          controls
          [src]="image"
          (error)="onErrorCarga()"
        ></video>
      </vg-player>
    </div>
  </div>
</section>
